/**
 * metroDisplay — Title-Case display formatter for metro names.
 *
 * Rule (2026-07-21 dispatch): storage/keys/slugs stay lowercase
 * (`omaha`, `kansas_city`, `dfw`), display copy is Title-Case
 * (`Omaha`, `Kansas City`, `Dallas–Fort Worth`). Live-prod audit
 * caught the admin `Service Areas` header rendering the raw
 * lowercase id.
 *
 * Locked mapping — carried verbatim from the prior batch spec.
 * `dfw` uses the EN DASH (U+2013) between "Dallas" and
 * "Fort Worth" per brand style. Any new launch metro added to
 * this table MUST also be added to the `/public/metros` server
 * seed with a matching `label` — the drift-guard in
 * `metroDisplay.test.js` pins this exact set.
 *
 * If a metro id comes back that isn't in the mapping, fall back
 * to the raw id so a future metro launching without a mapping
 * entry renders SOMETHING (backward-compat) — the raw id still
 * makes semantic sense to an admin operator; the fallback simply
 * flags "no display mapping yet, extend `METRO_DISPLAY_NAMES`".
 */
export const METRO_DISPLAY_NAMES = Object.freeze({
  omaha: "Omaha",
  kansas_city: "Kansas City",
  dfw: "Dallas\u2013Fort Worth",
  phoenix: "Phoenix",
  denver: "Denver",
});

/**
 * @param {string | null | undefined} metroId lowercase metro slug
 * @returns {string} Title-Case display name (or the raw id if
 *   unknown; empty string if the id itself is empty).
 */
export function toMetroDisplay(metroId) {
  if (metroId === null || metroId === undefined) return "";
  const key = String(metroId);
  if (Object.prototype.hasOwnProperty.call(METRO_DISPLAY_NAMES, key)) {
    return METRO_DISPLAY_NAMES[key];
  }
  return key;
}
